/** AUTO GENERATED FILE, DO NOT CHANGE MANUALLY */
/** SEE: api/ConstClassFactory */
import {StickyEventProps} from './StickyEventProps.model'
export const StickyEvent: StickyEventProps = {
dropdownOpen: 'dropdownOpen',
modalOverlayClick: 'modalOverlayClick',
selectOpen: 'selectOpen',
widgetTitleClick: 'widgetTitleClick',
}